import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CheckCircle2, Star, Users, BookOpen, MapPin } from 'lucide-react';
import { Button } from '../ui/Button';
export function Hero() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  return <section className="relative pt-16 pb-12 md:pt-24 md:pb-16 overflow-hidden bg-wood-dark text-cream wood-texture" data-id="element-94">
      <div className="absolute inset-0 bg-wood-dark/80 mix-blend-multiply" data-id="element-95"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-96">
        <motion.div className="max-w-4xl mx-auto text-center" variants={containerVariants} initial="hidden" animate="visible" data-id="element-97">
          <motion.h1 variants={itemVariants} className="text-4xl md:text-6xl lg:text-7xl font-black mb-4 leading-tight text-white" data-id="element-98">
            SUPER COMBO <br className="hidden md:block" data-id="element-99" />
            <span className="text-amber" data-id="element-100">CARPINTERÍA PLEGABLE PRO</span>
          </motion.h1>

          <motion.div variants={itemVariants} className="bg-wood-medium/40 border border-wood-light/30 p-5 md:p-6 rounded-2xl mb-8 backdrop-blur-sm" data-id="element-101">
            <p className="text-lg md:text-xl italic font-serif text-amber-light" data-id="element-102">
              "Planos listos. Herrajes calculados. Precios definidos. Todo para
              fabricar y vender muebles plegables en Argentina."
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="mb-8" data-id="element-103">
            <motion.img src="https://cdn.magicpatterns.com/uploads/9gdXNwdVx7vFp8cA9ARTc3/heylloyd-image-1775872679322.png" alt="Super Combo Carpintería Plegable PRO" className="mx-auto max-w-xs md:max-w-md lg:max-w-lg w-full drop-shadow-2xl" animate={{
            y: [0, -8, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-104" />
          </motion.div>

          <motion.div variants={itemVariants} className="mb-8" data-id="element-105">
            <Button href="#comprar" size="xl" className="w-full md:w-auto" data-id="element-106">
              QUIERO MI SUPER COMBO AHORA
            </Button>
          </motion.div>

          <motion.div variants={itemVariants} className="flex flex-wrap justify-center items-center gap-4 mb-10 text-sm text-cream-dark/80" data-id="element-107">
            <span className="flex items-center" data-id="element-108">
              <ShieldCheck className="w-4 h-4 mr-1.5 text-amber" data-id="element-109" /> Garantía 7
              días
            </span>
            <span className="text-wood-light" data-id="element-110">|</span>
            <span className="flex items-center" data-id="element-111">
              <CheckCircle2 className="w-4 h-4 mr-1.5 text-amber" data-id="element-112" /> Acceso
              inmediato
            </span>
            <span className="text-wood-light" data-id="element-113">|</span>
            <span className="flex items-center" data-id="element-114">
              <CheckCircle2 className="w-4 h-4 mr-1.5 text-amber" data-id="element-115" /> Mercado
              Pago
            </span>
          </motion.div>

          <motion.div variants={itemVariants} className="grid grid-cols-2 md:grid-cols-4 gap-3 bg-wood-medium/30 border border-wood-light/20 rounded-xl p-4 backdrop-blur-sm" data-id="element-116">
            <div className="flex flex-col items-center text-center" data-id="element-117">
              <Users className="w-6 h-6 mb-1 text-amber" data-id="element-118" />
              <span className="text-xl font-bold text-white" data-id="element-119">+500</span>
              <span className="text-[10px] text-cream-dark/70 uppercase tracking-wider" data-id="element-120">
                Carpinteros
              </span>
            </div>
            <div className="flex flex-col items-center text-center" data-id="element-121">
              <BookOpen className="w-6 h-6 mb-1 text-amber" data-id="element-122" />
              <span className="text-xl font-bold text-white" data-id="element-123">6+6</span>
              <span className="text-[10px] text-cream-dark/70 uppercase tracking-wider" data-id="element-124">
                Tomos + Bonos
              </span>
            </div>
            <div className="flex flex-col items-center text-center" data-id="element-125">
              <div className="flex mb-1" data-id="element-126">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-amber fill-amber" data-id="element-127" />)}
              </div>
              <span className="text-xl font-bold text-white" data-id="element-128">4.9/5</span>
              <span className="text-[10px] text-cream-dark/70 uppercase tracking-wider" data-id="element-129">
                Calificación
              </span>
            </div>
            <div className="flex flex-col items-center text-center" data-id="element-130">
              <MapPin className="w-6 h-6 mb-1 text-amber" data-id="element-131" />
              <span className="text-xl font-bold text-white" data-id="element-132">🇦🇷</span>
              <span className="text-[10px] text-cream-dark/70 uppercase tracking-wider" data-id="element-133">
                Todo el país
              </span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}